import { useEffect } from 'react';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import { siteInfo } from '@/mocks/data';

export default function Home() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  const websiteJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteInfo.name,
    url: siteInfo.url,
    description: siteInfo.description,
    inLanguage: 'zh-CN',
  };

  const organizationJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteInfo.name,
    url: siteInfo.url,
    description: siteInfo.description,
    contactPoint: {
      '@type': 'ContactPoint',
      email: siteInfo.contact.email,
      telephone: siteInfo.contact.phone,
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(organizationJsonLd)}</script>
      <Hero />
      <CategoryGrid />
      <FeaturedArticles />
      <FAQSection />

      <section className="w-full bg-accent-500 py-16">
        <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
            开始探索一区二区
          </h2>
          <p className="text-background-50/80 mb-8 max-w-[500px] mx-auto">
            无论您是新手还是资深用户，一区二区导航都能帮您找到最合适的资源。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="/category/yiqu-overview"
              className="px-8 py-3 bg-background-50 text-accent-600 rounded-lg text-sm font-semibold hover:bg-background-100 transition-colors whitespace-nowrap"
            >
              探索一区
            </a>
            <a
              href="/category/erqu-overview"
              className="px-8 py-3 bg-accent-600 text-background-50 rounded-lg text-sm font-semibold hover:bg-accent-700 transition-colors whitespace-nowrap"
            >
              探索二区
            </a>
          </div>
        </div>
      </section>
    </>
  );
}